import { makeStyles } from '@material-ui/core/styles';
import { createFactoryStyles } from '../../styles/helpers';
export const useStyles = makeStyles(({ factory: factoryTheme }) => {
    return createFactoryStyles({
        root: {
            color: `${factoryTheme.palette.purple[100]} !important`,
            fontSize: '24px',
            marginRight: factoryTheme.spacing(3),
        },
    });
});
